import { Col, Row, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { FaChevronRight } from "react-icons/fa";
import { Link } from 'react-router-dom'
import { getPackageDataDestinationId } from '../../../services/holiday/holidayServices';
import { Holiday_Banner } from '../../../utils/ImagePath';


const AllPackagesbyDestination = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [packageData, setPackageData] = useState({});

    const fetchPackageData = () => {
        setLoading(true);
        getPackageDataDestinationId()
            .then((response) => {
                setPackageData(response)
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching package data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPackageData();
    }, [])

    const formatPackageName = (slug) => {
        return slug + '-holiday-packages';
    };


    return (
        <>
            <section className='PackageBanner'>
                <img loading="lazy" src={Holiday_Banner} alt="" />
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2 className=''>Holidays by Destination  </h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="room-area domestic-area">
                <div className='Vacation-area'>
                    <div className="container">
                        <div className="section-title"><div><h3 className='pt-4 pt-md-5'>Holidays by Destination  </h3>
                            <span className="top-title">Enjoy hassle free bookings with <b>SuperbWorldTrip.com</b></span></div>
                        </div>

                        <Row gutter={16} className="g-lg-4 gy-5 mb-70 text-center">
                            {packageData?.length > 0 ? (
                                packageData?.map((pkg, index) => (
                                    <Col key={index} lg={8} md={12} xs={24}>
                                        <div className="tr-trip-item mb-5">
                                            <div className="tr-trip-thumb fix">
                                                <Link aria-label="package link" to={`/destination/${formatPackageName(pkg.slug)}`}>
                                                    <img loading="lazy" src={pkg?.image_url} alt={pkg?.name} className="package-img" height={'220px'} />
                                                </Link>
                                            </div>
                                            <div className="tr-trip-content">
                                                <div className="d-flex align-items-center justify-content-between text-start">
                                                    <div>
                                                        <h3 className="tr-trip-title">
                                                            <Tooltip title={pkg?.name}>
                                                                <Link aria-label="package link" to={`/destination/${formatPackageName(pkg.slug)}`}>
                                                                    {pkg?.name}
                                                                </Link>
                                                            </Tooltip>
                                                        </h3>
                                                        <h4 className='d-none'>
                                                        <svg width="1em" height="1em" viewBox="-1.5 0 15 15" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#000000" fillRule="evenodd" d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z" transform="translate(-568 -105)"></path> </g></svg>
                                                            {pkg?.name}, India
                                                        </h4>
                                                    </div>
                                                    <div className="tr-trip-price text-end">
                                                        <Link aria-label="package link" className="btn btn-primary" to={`/destination/${formatPackageName(pkg.slug)}`}>
                                                            Explore Now <FaChevronRight className='d-md-block d-none' />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                            ) : (
                                <div>No packages available.</div>
                            )}
                        </Row>


                    </div>
                </div>
            </section>
        </>
    )
}

export default AllPackagesbyDestination
